export const hospitalsFormSchema = [
  {
    id: "id",
    dataType: "integer",
    shownOnForm: false,
    label: "ID",
    value: 0,
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "code",
    dataType: "Text",
    shownOnForm: true,
    label: "Hospital Code",
    value: "",
    isRequired: true,
    maxChar: 30,
    fieldType: "textfield",
    pattern: /^[a-zA-Z0-9\-\_]+$/,
    patternMessage: "Invalid code. Use letters, numbers, -, or _",
  },
  {
    id: "name",
    dataType: "Text",
    shownOnForm: true,
    label: "Hospital Name",
    value: "",
    isRequired: true,
    maxChar: 255,
    fieldType: "textfield",
  },
  {
    id: "adminName",
    dataType: "Text",
    shownOnForm: true,
    label: "Admin Name",
    value: "",
    isRequired: true,
    maxChar: 255,
    fieldType: "textfield",
  },
  {
    id: "adminEmail",
    dataType: "Text",
    shownOnForm: true,
    label: "Admin Email",
    value: "",
    isRequired: true,
    maxChar: 255,
    fieldType: "textfield",
  },
  {
    id: "adminPassword",
    dataType: "Text",
    shownOnForm: true,
    label: "Admin Password",
    value: "",
    isRequired: false, // Optional on edit
    maxChar: 255,
    fieldType: "password",
  },
];

export const hospitalsRecord = {
  id: 0,
  code: "",
  name: "",
  adminName: "",
  adminEmail: "",
  adminPassword: "",
};
